document.addEventListener("DOMContentLoaded", function () {
    let isCaptchaOn = (recaptchaData && recaptchaData.isCaptchaOn) || false;
    window.recaptchaKey = window.recaptchaKey || (recaptchaData && recaptchaData.siteKey) || null;
    const SCORE_THRESHOLD = recaptchaData.scoreRate ? recaptchaData.scoreRate : 0.5;

    let preloader = $("<div>", {
        class: "recaptcha-preloader"
    }).html(`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 529.55 311.39">
            <path fill-rule="evenodd" d="M449.786 0 336.554 311.39h80.207l112.79-311ZM187.149 124.241c1.074-2.241 18.234-36.172 66.052-36.172 74.614 0 72.343 69.2 72.343 69.2V311.39h-64.48V169.849c-.325-8.154-3.158-29.881-29.881-29.881-25.255 0-33.659 16.726-36.172 36.172v135.25h-62.906V174.567c-.107-6.112-2.274-34.6-31.454-34.6-32.623 0-37.744 27.954-37.744 53.471V311.39H0V94.361h62.908v22.02c6.906-10.049 24.96-28.308 59.762-28.308 45.306 0 60.642 27.027 64.48 36.172Z" stroke="#58cb60" fill="transparent"/>
        </svg>
    `);

    if (!window.recaptchaKey) {
        console.error("reCAPTCHA key not found!");
        return;
    }

    function attachRecaptchaToForm($form) {
        if (!$form || !$form.length) {
            return;
        }

        let submitButton = $form.find("button[type='submit'], input[type='submit']");
        if (!submitButton.length) return;

        submitButton.on("click", function (event) {
            if (isCaptchaOn == 1) {

                if (!$form[0].checkValidity()) {
                    $form[0].reportValidity();
                    return;
                }

                preloader.get(0).classList.add('recaptcha-preloader--show');
                event.preventDefault();
                $form.find(".recaptcha-error").remove();

                grecaptcha.ready(function () {
                    grecaptcha.execute(window.recaptchaKey, {
                            action: "submit"
                        })
                        .then(function (token) {
                            let recaptchaInput = $form.find("input[name='g-recaptcha-response']");
                            if (!recaptchaInput.length) {
                                recaptchaInput = $("<input>", {
                                    type: "hidden",
                                    name: "g-recaptcha-response",
                                    value: token,
                                });
                                $form.append(recaptchaInput);
                            } else {
                                recaptchaInput.val(token);
                            }

                            const formData = new FormData();
                            formData.append("token", token);

                            fetch('/wp-admin/admin-ajax.php?action=verify_recaptcha', {
                                    method: 'POST',
                                    body: formData
                                })
                                .then(response => response.json())
                                .then(data => {
                                    let scoreInput = $form.find("input[name='recaptcha_score']");

                                    if (scoreInput) {
                                        scoreInput.val(data.data.score);
                                    }
                                    preloader.get(0).classList.remove('recaptcha-preloader--show');
                                    if (data.data.success && data.data.score >= SCORE_THRESHOLD) {
                                        $form.off("submit").submit();
                                        // $form[0].submit();
                                    } else {
                                        const errorMessage = $("<span>", {
                                            class: "recaptcha-error",
                                            text: "Please try again later",
                                        });
                                        $form.append(errorMessage);
                                    }
                                })
                                .catch(error => {
                                    preloader.get(0).classList.remove('recaptcha-preloader--show');
                                    console.error("reCAPTCHA check error:", error);
                                });
                        })
                        .catch(function (error) {
                            preloader.get(0).classList.remove('recaptcha-preloader--show');
                            console.error("reCAPTCHA token receive error:", error);
                        });
                });


            } else {
                setTimeout(() => {
                    if ($form.find(".hs-error-msg").length === 0) {
                        preloader.get(0).classList.add("recaptcha-preloader--show");
                    }
                }, 200);
            }
        });
    }

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) {
                    let form = node.tagName === "FORM" ? node : node.querySelector("form.hs-form-private");
                    if (form && form.classList.contains('hs-form-private')) {
                        $(form).css("position", "relative").append(preloader);
                        if ($(form).closest('.form-rest').length > 0) {
                            selectInit($(form));
                        }
                        setRequiredCheckbox($(form));
                        monitorFormInputs($(form));
                        setTextareaSize($(form));
                        setTimeout(() => {
                            attachRecaptchaToForm($(form));
                        }, 500);
                    }
                }
            });
        });
    })

    function setTextareaSize($form) {
        if (!$form || !$form.find) return;

        $form.find('textarea').each(function () {
            if (!this || !$(this).closest('.form-rest').length) return;

            const $textarea = $(this);
            if (!$textarea.length) return;

            const minHeight = 44;

            function updateHeight() {
                this.style.height = "auto";
                let computedStyle = window.getComputedStyle(this);
                let paddingTop = parseFloat(computedStyle.paddingTop) || 0;
                let paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
                let newHeight = this.scrollHeight - paddingTop - paddingBottom;

                if (this.value.trim().length === 0) {
                    this.style.height = `${minHeight}px`;
                } else {
                    this.style.height = `${Math.max(newHeight, minHeight)}px`;
                }
            }

            this.style.setProperty("height", `${minHeight}px`, "important");
            $textarea.on("input", updateHeight);
            updateHeight.call(this);
        });
    }


    function setRequiredCheckbox($form) {
        $form.find('.hs-form-booleancheckbox').each(function () {
            const $container = $(this);
            const $checkbox = $container.find("input[type='checkbox']");
            const requiredIndicator = $container.find('.hs-form-required');

            if (requiredIndicator.length && $checkbox.length) {
                $checkbox[0].setAttribute('required', 'required');
            }
        });
    }

    function monitorFormInputs($form) {
        $form.find("input, textarea, select").each(function () {
            toggleNotEmptyClass($(this));
        });

        $form.on("input propertychange change", "input, textarea, select", function () {
            toggleNotEmptyClass($(this));
        });

        $form.on("change", "select", function () {
            setTimeout(() => {
                $form.find("input, textarea, select").each(function () {
                    toggleNotEmptyClass($(this));
                });
            }, 500);
        });
    }

    function toggleNotEmptyClass($input) {
        if ($input.is("textarea")) {
            if ($input.text().trim()) {
                $input.attr("data-not-empty", "true");
            } else {
                $input.removeAttr("data-not-empty");
            }
        } else if ($input.is("select")) {
            if ($input.val()) {
                $input.attr("data-not-empty", "true");
            } else {
                $input.removeAttr("data-not-empty");
            }
        } else {
            if ($input.val().trim()) {
                $input.attr("data-not-empty", "true");
            } else {
                $input.removeAttr("data-not-empty");
            }
        }
    }

    function selectInit($form) {
        if (typeof $form === 'undefined' || !$form.length) return;

        const $originalSelect = $form.find('select');
        if (!$originalSelect.length) return;


        const $customSelectWrapper = $('<div>').addClass('custom-select-hubspot');
        const $customSelect = $('<div>').addClass('custom-select');
        const $customSelectText = $('<span>').addClass('custom-select-text').text('');
        const $customSelectOptions = $('<div>').addClass('custom-select-options');

        $customSelect.append($customSelectText);

        $originalSelect.find('option').each(function () {
            const $option = $(this);

            if (!$option || !$option.length) return;
            if ($option.prop('disabled') || !$option.val()) return;

            const value = $option.val();
            const text = $option.text();

            if (typeof value === 'undefined' || typeof text === 'undefined') return;

            const $customOption = $('<div>')
                .addClass('custom-select-option')
                .text(text)
                .data('value', value);

            $customOption.on('click', function (e) {
                e.stopPropagation();

                const selectedValue = $(this).data('value');
                const selectedText = $(this).text();

                if (typeof selectedValue === 'undefined' || typeof selectedText === 'undefined') return;

                $originalSelect.val(selectedValue).trigger('change');
                $originalSelect.attr('data-not-empty', true);
                $customSelectText.text(selectedText);
                $customSelectOptions.slideUp(400);
                $customSelectWrapper.removeClass('open');
            });

            $customSelectOptions.append($customOption);
        });

        $customSelect.append($customSelectOptions);
        $customSelectWrapper.append($customSelect);
        $originalSelect.after($customSelectWrapper);



        $customSelect.on('click', function (e) {
            e.stopPropagation();

            if ($customSelectWrapper.hasClass('open')) {
                $customSelectOptions.slideUp(400);
                $customSelectWrapper.removeClass('open');
            } else {
                $customSelectOptions.stop(true, true).slideDown(400);
                $customSelectWrapper.addClass('open');
            }
        });

        $(document).on('click', function (event) {
            if (!$customSelectWrapper.is(event.target) && $customSelectWrapper.has(event.target).length === 0) {
                $customSelectOptions.slideUp(400);
                $customSelectWrapper.removeClass('open');
            }
        });
    }


    observer.observe(document.body, {
        childList: true,
        subtree: true
    });


});
document.addEventListener("DOMContentLoaded", function () {
    function isFirefox() {
        return navigator.userAgent.toLowerCase().includes("firefox");
    }


    setTimeout(function () {
        const formLoaded = document.querySelector(".hbspt-form form");

        if (isFirefox() && !formLoaded) {
            const warningMessage = document.createElement("div");
            warningMessage.className = "form-security";

            warningMessage.innerHTML = `
                <div class="form-security__logo">
                    <svg xmlns='http://www.w3.org/2000/svg' width='108' height='65' fill='none' viewBox='0 0 108 65'>
                        <path fill='#C6CFDD'
                            d='m91.387.5-22.876 64h16.114L107.5.5H91.387ZM38.281 26.476c.217-.455 3.71-7.473 13.354-7.473 15.048 0 14.396 14.16 14.396 14.16v31.336H53.264V35.85c-.066-1.655-.734-6.227-6.123-6.227-5.093 0-6.79 3.418-7.296 7.365v27.511H27.077V36.733c-.021-1.24-.434-7.11-6.318-7.11-6.58 0-7.492 5.704-7.492 10.882V64.5H.5V20.314h12.768v4.617c1.392-2.04 4.967-5.928 11.985-5.928 9.137 0 12.233 5.617 13.007 7.473h.021Z' />
                    </svg>
                </div>
                <div class="form-security__content">
                    <p class="form-security__heading">
                        OOPS!
                    </p>
                    <p class="form-security__text">
                        It looks like your browser's security settings are blocking the form. Please enable plugins for this site to proceed.
                    </p>
                </div>
            `;

            const hubspotScript = document.querySelector("script[src*='js.hsforms.net']");
            if (hubspotScript && hubspotScript.parentNode) {
                const existingWarning = hubspotScript.parentNode.querySelector(".form-security");
                if (!existingWarning) {
                    hubspotScript.parentNode.insertBefore(warningMessage, hubspotScript);
                }
            } else {
                document.body.appendChild(warningMessage);
            }
        }

        document.querySelectorAll(".footer__subscribe-form").forEach(function (formFooter) {
            const formFooterLoaded = formFooter.querySelector(".hbspt-form form");
            if (isFirefox() && formFooter && !formFooterLoaded) {

                const warningMessage = document.createElement("div");
                warningMessage.className = "form-security";

                warningMessage.innerHTML = `
                <div class="form-security__logo">
                    <svg xmlns='http://www.w3.org/2000/svg' width='108' height='65' fill='none' viewBox='0 0 108 65'>
                        <path fill='#C6CFDD'
                            d='m91.387.5-22.876 64h16.114L107.5.5H91.387ZM38.281 26.476c.217-.455 3.71-7.473 13.354-7.473 15.048 0 14.396 14.16 14.396 14.16v31.336H53.264V35.85c-.066-1.655-.734-6.227-6.123-6.227-5.093 0-6.79 3.418-7.296 7.365v27.511H27.077V36.733c-.021-1.24-.434-7.11-6.318-7.11-6.58 0-7.492 5.704-7.492 10.882V64.5H.5V20.314h12.768v4.617c1.392-2.04 4.967-5.928 11.985-5.928 9.137 0 12.233 5.617 13.007 7.473h.021Z' />
                    </svg>
                </div>
                <div class="form-security__content">
                    <p class="form-security__heading">
                        OOPS!
                    </p>
                    <p class="form-security__text">
                        It looks like your browser's security settings are blocking the form. Please enable plugins for this site to proceed.
                    </p>
                </div>
            `;


                if (!formFooter.querySelector(".form-security")) {
                    formFooter.appendChild(warningMessage);
                }
            }
        });
    }, 2000);


});



document.addEventListener("DOMContentLoaded", function () {
    // Minimal-risk guard: the Gutenberg HubSpot block already enhances file inputs
    // (see `gutenberg-native-blocks/src/hubspot-form/variants/behavior-hero-landing.js`).
    // Running both implementations can double-bind handlers and break max-file logic.
    if (document.querySelector(".wp-block-mobidev-hubspot-form")) {
        return;
    }

    let checkExist = setInterval(function () {
        let fileInput = document.querySelector(".hs-input[type='file']");

        if (fileInput && fileInput.closest(".input")) {
            clearInterval(checkExist);

            let inputWrapper = fileInput.closest(".input");
            fileInput.classList.add("custom-hidden-file-input");
            inputWrapper.classList.add("custom-file-upload");
            inputWrapper.setAttribute("data-file-name", "ADD YOUR FILE HERE");

            let fileList = document.createElement("div");
            fileList.classList.add("file-list");
            inputWrapper.appendChild(fileList);

            let currentFiles = [];
            const maxFiles = 5;
            const maxFileSize = 25 * 1024 * 1024;
            let suppressProgrammaticChange = false;

            function fileIdentity(file) {
                // After DataTransfer round-trips, lastModified can change; name+size is stable enough here.
                return `${file.name}::${file.size}`;
            }

            function dedupeCurrentFiles() {
                const seen = new Set();
                const deduped = [];
                currentFiles.forEach((file) => {
                    const key = fileIdentity(file);
                    if (seen.has(key)) return;
                    seen.add(key);
                    deduped.push(file);
                });
                currentFiles = deduped;
            }

            fileInput.addEventListener("change", function () {
                if (suppressProgrammaticChange) {
                    return;
                }

                dedupeCurrentFiles();

                const nextFiles = Array.from(this.files || []);
                const existingKeys = new Set(currentFiles.map((f) => fileIdentity(f)));
                const batchKeys = new Set();
                const filesToAdd = [];

                nextFiles.forEach((file) => {
                    const key = fileIdentity(file);
                    if (existingKeys.has(key) || batchKeys.has(key)) return;
                    batchKeys.add(key);
                    filesToAdd.push(file);
                });

                if (currentFiles.length + filesToAdd.length > maxFiles) {
                    alert(`Max attachment count should not be more than ${maxFiles}`);
                    return;
                }

                filesToAdd.forEach((file) => {
                    if (file.size > maxFileSize) {
                        alert("File size should not exceed 25 MB.");
                        return;
                    }
                    currentFiles.push(file);
                    addFileToList(file, currentFiles.length - 1);
                });

                updateFileInput();
            });

            function addFileToList(file, index) {
                let fileItem = document.createElement("div");
                fileItem.classList.add("file-item");
                fileItem.setAttribute("data-index", index);

                let fileName = document.createElement("span");
                fileName.textContent = file.name;
                fileName.classList.add("file-name-display");

                let fileSize = document.createElement("span");
                fileSize.textContent = `( ${formatFileSize(file.size)} )`;
                fileSize.classList.add("file-size-display");

                let removeButton = document.createElement("button");
                removeButton.classList.add("reset-file-input");
                removeButton.setAttribute("type", "button");
                removeButton.setAttribute("data-index", index);

                removeButton.addEventListener("click", function (event) {
                    event.stopPropagation(); // Prevent triggering file input
                    let fileIndex = parseInt(this.getAttribute("data-index"));
                    removeFile(fileIndex);
                });

                fileItem.appendChild(fileName);
                fileItem.appendChild(fileSize);
                fileItem.appendChild(removeButton);
                fileList.appendChild(fileItem);
            }

            function formatFileSize(bytes) {
                let sizes = ['B', 'KB', 'MB', 'GB'];
                if (bytes === 0) return '0 B';
                let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
            }

            function removeFile(index) {
                currentFiles.splice(index, 1);
                updateFileInput();
                fileList.innerHTML = "";
                currentFiles.forEach((file, i) => addFileToList(file, i));
            }

            function updateFileInput() {
                dedupeCurrentFiles();
                let dt = new DataTransfer();
                currentFiles.forEach(file => dt.items.add(file));
                suppressProgrammaticChange = true;
                fileInput.files = dt.files;
                // Some browsers dispatch the synthetic change after the current tick.
                setTimeout(() => {
                    suppressProgrammaticChange = false;
                }, 0);
            }
        }
    }, 500);
});